import { BaseModel } from "../base.model";
import { CategoryModel } from "./category-model";
import { CustomFieldModel } from "./custom-field-model";
import { DocumentModel } from "./document-model";

export enum TemplateDocumentType {
    Document = 0,
    Invoice = 1,
    Cheque = 2,
    Retainer = 3,
    Questionnaire = 4,
    Other = 5,
    Strategy = 6,
    Marketplace = 7
}

export enum DocumentStatus {
    New = 0, //not saved 
    Signed = 1,
    Approved = 2,
    Completed = 3,
    Rejected = 4,
    PendingApproval = 5,
    Processed = 6,
}

export class DocumentTemplateModel extends BaseModel {
    type?: TemplateDocumentType; 
    status?: DocumentStatus;
    categoryId?: string;
    imageUrl?: string;
    name?: string;
    description?: string;
    text?: string;
    document?: DocumentModel;
    price: number = 0;
    processingFee: number = 0;
    additionalFee: number = 0;
    customFields?: CustomFieldModel[] = [];
    category?: CategoryModel;
    isIcon: boolean = true;
    isExplicitIdentityRequired?: boolean = false;
    coverPhotoFileId?: string;
    profilePhotoFileId?: string;

    //ui only
    coverImageURL: any;
}